import { render, staticRenderFns } from "./settings.page.vue?vue&type=template&id=1fdec1e0&scoped=true"
import script from "./settings.page.vue?vue&type=script&lang=js"
export * from "./settings.page.vue?vue&type=script&lang=js"
import style0 from "./settings.page.vue?vue&type=style&index=0&id=1fdec1e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdec1e0",
  null
  
)

export default component.exports